//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Toast } from 'mint-ui';
import {formatTime,guid} from "@/utils/common"
import {BASIC,FLYBACK_URL} from "@/config/constant"
import promise from '@/axios/promise';
  export default {
    name: 'dayReportAuditList',
    data() {
      return {
        searchInfo: {
            projName:'',
            status:'待审批',
            page:1,
            limit:10
        },
        active1:0,
        loading:false,
        refreshing:false,
        auditStatus:"已通过",
        auditRemark:'',
        checkAllFlag:false,
        disabled:true,
        reportDetailList:[],
        userTypeList:[],
        data: {

        }
      }
    },
    methods: {
      //返回
      goBack() {
        this.$router.push({path:'/'});
      },
      statusChange(status){
          this.searchInfo.status=status;
          this.checkAllFlag=false;
          this.getAuditData('reload');
      },
      auditDetail(data){
          this.$router.push({path:'/app/audit/dayReportAuditDetail',query:{'data':data}});
      },
      getAuditData(type){
          if(type=='reload'){
            this.searchInfo.page=1;
          }else{
            this.searchInfo.page++;
          }
          //设置页码
          promise({
              url:BASIC+'/dayReport/audit/list/page',
              params:this.searchInfo,
              methed:'get'
          }).then(res=>{
             this.loading = false;
             console.log(JSON.stringify(res.data));
              res.data.forEach(element => {
                    element.checked=false;
               });
               if(type=='reload'){
                 this.reportDetailList=res.data;
               }else{
                 res.data.forEach(element => {
                   this.reportDetailList.push(element);
                 });
               }
          });
      },
      load(){
        this.loading=true;
        this.getAuditData('loadMoere');
      },
      checkAll(val){
          this.reportDetailList.forEach(element => {
             element.checked=val;
            if(element.flybackList!=null && element.flybackList.length>0){
                element.checked=false;;
            }
          });
      },
      auditPass(){
          this.auditStatus='已通过';
          this.prompt();
      },
      auditRefuse(){
          this.auditStatus='被驳回';
          this.prompt();
      },
      changeStatus(){
        if(this.active1==0){
            this.statusChange('待审批');
        }else if(this.active1==1){
          this.statusChange('已通过');

        }else if(this.active1==2){
          this.statusChange('被驳回');

        }
      },
      prompt () {
          var ids=[];
          var flag=true;

          this.reportDetailList.forEach(row => {
              if(row.checked){
                  ids.push(row.id);
                  if(row.flybackList!=null && row.flybackList.length>0){
                    flag=false;
                  }
              }
          });
          if(ids==null || ids.length==0){
            Toast({  message: '请选择审批的数据！', duration: 1500,position: 'middle', className:"warning" });
            return;
          }
          if(!flag){
             Toast({  message: '含有差旅数据，不能批量审批！', duration: 1500,position: 'middle', className:"warning" });
              return;
          }
        this.$prompt('请输入审核意见', '提示', {

        }).then(({ result, value }) => {
            if (result) {
                this.auditRemark=value;
                this.auditReport();
            } else {
                this.auditRemark='';
            }
        });
      },
      auditReport(){
          var ids=[];
          this.reportDetailList.forEach(row => {
              if(row.checked){
                  ids.push(row.id);
              }
          });
          promise({
              url:BASIC+'/dayReport/audit',
              method:'put',
              params:{status:this.auditStatus,auditRemark:this.auditRemark,idsStr:JSON.stringify(ids)}
          }).then(res=>{
              this.page=1;
              this.auditRemark='';
              this.getAuditData('reload');
          });
      },
      refresh () {
        this.refreshing = true;
        this.$refs.container.scrollTop = 0;
        setTimeout(() => {
          this.getAuditData('reload');
          this.refreshing = false;
        }, 2000)
      },
      compareDate(reportTime,createTime){
         return formatTime(new Date(reportTime),'yyyy-MM-dd')==formatTime(new Date(createTime),'yyyy-MM-dd')
      },
      getClass(data){
          if(data.workTotalSubsidy!=data.origTotalSubsidy){
            return 'colorYellow';
          }
          if(data.workSubsidy!=data.origSubsidy){
            return 'colorYellow';
          }
       },
        getSubsidyClass(data){
          if(data.workSubsidy>0){
            return 'colorRed';
          }
       },
      getUserTypeList(){
          promise({
            url:BASIC+"/dic/item/list/cateCode",
            mounted:'get',
            params:{cateCode:'userType'}
          }).then(res=>{
            this.userTypeList=res;
          });
        },
    },
    filters: {
       filterDate(date){
         if(date==null || date==''){
           return '';
         }
          return formatTime(new Date(date),'yyyy年MM月dd日')
       },
       filterDate1(date){
         if(date==null || date==''){
           return '';
         }
          return formatTime(new Date(date),'yyyy-MM-dd')
       },
       timeFilter(date){
          if(date==null || date==''){
            return '';
          }
          return formatTime(new Date(date),'hh:mm')
       },
      userTypeFilter(userType){
        if (userType == "outside") {
          return "外部";
        }
        return "内部";
      },
    },
    created() {
        this.getAuditData('reload');
    },
    mounted() {

    }
  }



// WEBPACK FOOTER //
// ./src/view/sign/dayReportAuditList.vue